import React, {useState, useEffect, useContext } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonFooter } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../../../css/layout.css';
import { ViewAttachement_ImageModal } from '../../../zInternal_Features/merchant/components/Modal_ViewAttachement_Image';

export function EstimateDetailsModal(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewEstimateDetailData, setViewEstimateDetailData] = useState([]);


    let [estimateID, setEstimateID] = useState(null);
    let [totalAmount, setTotalAmount] = useState(null);
    let [paymentType, setPaymentType] = useState(null);
    let [imageAttachement, setImageAttachement] = useState(null);
    let [viewAttachementModal, setViewAttachemntModal] = useState(false);



   //getOccupiedRoomDetailData(instant_checkInRoomID) {
    useEffect(() => {

        //alert('In Occupied Detailed Data');
        //alert(props.openModal);


            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_estimate_details',
                    user: acctID,
                    xEstimateID: props.data.estimateID,
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');


                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setViewEstimateDetailData((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            estimateID: cols[0],
                            customerID: cols[1],
                            customerFirstName: cols[2],
                            customerLastName: cols[3],
                            customerMobileNumber: cols[4],
                            estimateDescription: cols[5],
                            estimateLatitude: cols[6],
                            estimateLongitude: cols[7],
                            dateLogged: cols[8],
                            estimateImage1: cols[9],
                            status: cols[10],
                            externalID: cols[11],
                        })
                    });
                } 
            })
        
    }, []);


    function conver_to_consult()
    {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_convert_to_consult',
                user: acctID,
                xEstimateID: props.data.estimateID,
                xCustomerAccountID: props.data.customerID,
                xExternalID: props.data.externalID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })
    }

    function viewEstimateAttachmentHandler(event) {

        //alert('In viewEstimateInvoiceHandler');
        //alert(event);
        //alert(event[0]);
        //alert(event[3]);
        //alert(event[4]);
        //alert(event[5]);

        // setTotalAmount(event[3]);
        // setPaymentType(event[4]);
        setImageAttachement(event[1]);

        setViewAttachemntModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function closeModalHandler() {

        setViewEstimateDetailData([]);
        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader style={{color: 'black'}}>
            <IonGrid >
                    <IonRow>
                        <IonCol> Estimate ID</IonCol>
                        <IonCol> {props.data.estimateID} </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='grid_content'>
            {viewEstimateDetailData.map((detailData) =>   {
            return (
            <IonGrid >
                <IonRow >
                    <IonCol >Category</IonCol>
                    <IonCol >Value</IonCol>
                    <IonCol >Action</IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Customer Name</IonCol>
                    <IonCol >{detailData.customerFirstName} {detailData.customerLastName}</IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Customer Phone</IonCol>
                    <IonCol >{detailData.customerMobileNumber}</IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Customer Location</IonCol>
                    <IonCol >{detailData.estimateLatitude} {detailData.estimateLongitude}</IonCol>
                    <IonCol >
                        <IonButton > View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Date Logged</IonCol>
                    <IonCol >{detailData.dateLogged}</IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Description</IonCol>
                    <IonCol style={{fontSize: 'small'}}>
                        <textarea cols="50" rows="10" value={detailData.estimateDescription} placeholder='Request Description' required></textarea>
                    </IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Attachment</IonCol>
                    <IonCol >
                       {viewAttachementModal == true && <ViewAttachement_ImageModal openModal={ viewAttachementModal } closeModal={() => setViewAttachemntModal(false)} data={{
                                                fileLocation: detailData.attachment, 
                                                }}></ViewAttachement_ImageModal>}

                        <IonButton onClick={() => viewEstimateAttachmentHandler([true, detailData.attachment])}> View </IonButton>

                    </IonCol>
                </IonRow>
            </IonGrid>
                    )
                }
            )}
        </IonContent>

        <IonFooter className='grid_footer'>
            <IonButton  onClick={() => conver_to_consult(props.data.estimateID, props.data.customerID, props.data.externalID)}> Convert to Consultation </IonButton>
            <IonButton onClick={closeModalHandler}> Close </IonButton>
        </IonFooter>

    </IonModal>) : null}
    </React.Fragment>
    )
}